/** CMS provider — each value is also its Rails proxy path segment (`/svcs/core/<provider>`). */
export const CMS_PROVIDER = {
  strapi: 'strapi',
  sanity: 'sanity'
} as const;
export type CmsProvider = (typeof CMS_PROVIDER)[keyof typeof CMS_PROVIDER];
